import React, { useEffect } from 'react';
import Header from '../../components/ui/Header';
import HeroSection from './components/HeroSection';
import WhyWeHoldEventSection from './components/WhyWeHoldEventSection';
import EventProgramSection from './components/EventProgramSection';
import PartnersSection from './components/PartnersSection';
import OrganizersSection from './components/partners/OrganizersSection';
import SponsorsSection from './components/partners/SponsorsSection';
import SuccessPartnersSection from './components/partners/SuccessPartnersSection';
import EventPartnersSection from './components/partners/EventPartnersSection';
import StatesSection from './components/StatesSection';
import CommunityGallery from './components/CommunityGallery';
import EngagementFormsSection from './components/EngagementFormsSection';
import GuestsSection from './components/GuestsSection';
import TimelineSection from './components/TimelineSection';
import ClosingCTASection from './components/ClosingCTASection';
import LanguageSelector from './components/LanguageSelector';
import FooterSection from './components/FooterSection';
import SectionDimensionsDisplay from '../../components/dev/SectionDimensionsDisplay';

const LandingPage = () => {
  const updatePageMetadata = (language) => {
    const titles = {
      ar: 'عامٌ على النصر - ٨ ديسمبر ٢٠٢٤، إسطنبول',
      en: 'A Year of Victory - December 8, 2024, Istanbul',
      tr: 'Zaferin Bir Yılı - 8 Aralık 2024, İstanbul'
    };
    const title = titles?.[language] || titles?.en;
    document.title = title;

    // Set meta description
    const descriptions = {
      ar: 'في الذكرى الأولى ليومٍ غيّر الوعي السوري، نجتمع لنستعيد اللحظة التي أعادت للوطن صوته، وللناس انتماءهم. سجِّل الآن للمشاركة في الفعالية.',
      en: 'On the first anniversary of a day that changed Syrian consciousness, we gather to reclaim the moment that restored the homeland\'s voice and people\'s sense of belonging. Register now to participate in the event.',
      tr: 'Suriye bilincini değiştiren bir günün ilk yıldönümünde, vatanın sesini ve halkın aidiyet duygusunu geri getiren anı yeniden kazanmak için bir araya geliyoruz. Etkinliğe katılmak için şimdi kayıt olun.'
    };
    const description = descriptions?.[language] || descriptions?.en;

    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', description);
    }

    // Update Open Graph tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) ogTitle.setAttribute('content', title);
    
    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) ogDescription.setAttribute('content', description);
    
    // Update Twitter Card tags
    const twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) twitterTitle.setAttribute('content', title);
    
    const twitterDescription = document.querySelector('meta[name="twitter:description"]');
    if (twitterDescription) twitterDescription.setAttribute('content', description);
  };

  useEffect(() => {
    // Set page title based on language
    const savedLanguage = localStorage.getItem('memorial-language') || 'ar';
    updatePageMetadata(savedLanguage);

    // Apply initial language settings
    const language = savedLanguage;
    document.documentElement.dir = savedLanguage === 'ar' ? 'rtl' : 'ltr';
    document.documentElement.lang = language;

    // Listen for language changes
    const handleLanguageChange = (event) => {
      const newLanguage = event.detail?.language || 'ar';
      updatePageMetadata(newLanguage);
    };

    window.addEventListener('languageChanged', handleLanguageChange);
    return () => window.removeEventListener('languageChanged', handleLanguageChange);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      {/* Header */}
      <Header />

      {/* Fixed Language Selector */}
      <div className="fixed top-4 right-4 z-language-selector">
        <LanguageSelector />
      </div>

      {/* Hero Section */}
      <HeroSection />

      {/* Why We Hold Event Section */}
      <WhyWeHoldEventSection />
      
      {/* Organizers Section - NEW */}
      <OrganizersSection />
      
      {/* Guests Section */}
      <GuestsSection />

      {/* Event Program Section */}
      <EventProgramSection />
    {/* Event Partners Section */}
      <EventPartnersSection />

      {/* States Section - NEW */}
      <StatesSection />

      {/* Sponsors Section */}
      <SponsorsSection />

      {/* Success Partners Section */}
      <SuccessPartnersSection />

      {/* Partners Section */}
      <PartnersSection />

      {/* Engagement Forms Section */}
      <EngagementFormsSection />

      {/* Timeline Section */}
      <TimelineSection />

      {/* Closing CTA Section */}
      <ClosingCTASection />

      {/* Footer Section */}
      <FooterSection />

      {/* Section Dimensions Display Utility (Dev Tool) */}
      {/* <SectionDimensionsDisplay /> */}
    </div>
  );
};

export default LandingPage;